import { render, staticRenderFns } from "./xcxindex.vue?vue&type=template&id=334c8017&scoped=true&"
import script from "./xcxindex.vue?vue&type=script&lang=js&"
export * from "./xcxindex.vue?vue&type=script&lang=js&"
import style0 from "./xcxindex.vue?vue&type=style&index=0&id=334c8017&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334c8017",
  null
  
)

component.options.__file = "xcxindex.vue"
export default component.exports